
import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputCheckBox from '../../commons/form/InputCheckBox'
import InputText from '../../commons/form/InputText'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'

import { handleKeyDown } from '../../../util/utils'

class operationTypeMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = { isFleet: false }
  }

  submitOperationType (values) {
    let body = []
    Object.keys(values).map(item => {
      if (typeof values[item] === 'object') {
        body.push(values[item])
      }
    })
    const operationType = {
      operationTypeId: this.props.operationType.operationTypeId,
      operationTypeLocales: body,
      isFleet: values.isFleet,
      code: values.code
    }

    if (this.props.initialValues.operationType.code !== operationType.code || this.props.initialValues.operationType.isFleet !== operationType.isFleet) {
      this.props.actions.openModal('confirmUpdateOperationType', () => this.props.actions.saveOperationType(operationType))
    } else {
      this.props.actions.saveOperationType(operationType)
    }
  }

  getEntityPromise (value) {
    return new Promise((resolve, reject) => {
      return this.props.actions.fetchClientByDni(value, this.props.organizedUnitId, null, resolve, reject)
    })
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      const operationType = this.props.operationType
      this.props.initialize(prevProps.operationType)
      this.props.languageList.map((language) => {
        this.props.change(`lang${language.languageId}.languageId`, language.languageId)
        const source = operationType && operationType.operationTypeLocales
          ? operationType.operationTypeLocales.find((sourceChannel) => sourceChannel.languageId === language.languageId)
          : null
        this.props.change(`lang${language.languageId}.name`, source?.name)
        this.props.change(`lang${language.languageId}.description`, source?.description)
        this.props.change('code', operationType?.code)
        this.props.change('isFleet', operationType?.isFleet ?? false)
      })
    }

    if (this.props.reactivatable !== prevProps.reactivatable) {
      if (!this.props.operationType.isFleet) {
        this.setState({ isFleet: false })
      } else {
        this.setState({ isFleet: this.props.operationType.isFleet })
      }
    }
    return prevProps
  }

  componentDidUpdate () {
    // don't remove use for getsnapshot
  }

  render () {
    const { t, showModal, handleSubmit, languageList = [] } = this.props
    const tKey = 'MASTERS'
    return (
      <Modal id="operationTypeMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeOperationTypeModal}
        backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}.OPERATION_TYPE_MASTER.OPERATION_TYPE`)}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitOperationType.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body >
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={80} // 25, 33, 50, 75, 100 default=25
                id="code"
                name="code"
                controlLabel={t(`${tKey}.OPERATION_TYPE_MASTER.CODE`)}
                placeholder={t(`${tKey}.OPERATION_TYPE_MASTER.CODE`)}
                maxLength= {50}
                type="text"
              />
              <Field
                component={InputCheckBox}
                colWidth={20} // 25, 33, 50, 75, 100 default=25
                name= "isFleet"
                id = "isFleet"
                placeholder ={t(`${tKey}.OPERATION_TYPE_MASTER.IS_FLEET`)}
              />
            </div>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />

          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="btn-wrapper">
              <Button type="submit" className="_Btn new">
                {t(`${tKey}.SAVE`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}
const validate = (values, props) => {
  const errors = { }
  props.languageList.map(language => {
    errors[`lang${language.languageId}`] = {}
    if (values[`lang${language.languageId}`]) {
      if (!(values[`lang${language.languageId}`].name)) {
        errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      }
      if (!(values[`lang${language.languageId}`].description)) {
        errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
      }
    } else {
      errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
    }
  })
  if (!values.code) { errors.code = props.t('MASTERS.VALIDATION.CODE_REQUIRED') }
  return errors
}

export default reduxForm({
  form: 'operationTypeMasterModal',
  validate
})(operationTypeMasterModal)
